import type { Theme } from '../../themes/themes';

export const createButtonGroupTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.default,
          display: 'flex',
          gap: theme.spacing(2),
          '& .MuiButton-standardSecondary': {
            boxShadow: 'none',
          },
        },
        grouped: {
          color: theme.palette.text.primary,
          borderRadius: theme.shape.borderRadius,
          border: `1px solid ${theme.palette.action.border}`,
          flexGrow: 1,
          padding: theme.spacing(5),
          '&:active, &[aria-selected=true]': {
            borderColor: 'transparent',
            backgroundColor: theme.palette.green.main,
            color: '#fff',
            '&:focus, &:hover': {
              borderColor: theme.palette.buttonGroup.backgroundActive,
              backgroundColor: theme.palette.buttonGroup.backgroundActive,
              color: '#fff',
            },
          },
          '&:hover': {
            boxShadow: 'none',
            color: '#FFFFFF',
            borderColor: theme.palette.action.border,
            backgroundColor: theme.palette.buttonGroup.backgroundHover,
          },
          '&:focus': {
            borderColor: theme.palette.action.focus,
          },
          '&:disabled, &.Mui-disabled': {
            color: theme.palette.buttonGroup.colorDisabled,
            backgroundColor: 'transparent',
            borderColor: theme.palette.buttonGroup.borderDisabled,
          },
          ':not(:last-of-type)': {
            borderRadius: theme.shape.borderRadius,
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
          },
          ':first-of-type, :last-of-type': {
            borderRadius: theme.shape.borderRadius,
            margin: 0,
          },
        },
      },
      defaultProps: {
        disableElevation: true,
        disableFocusRipple: true,
        disableRipple: true,
      },
    },
  },
});
